import { __rest } from './../../../../external/tslib/tslib.es6.js';
import React from 'react';
import { Flex } from '@olist/design-system';

function TableHeader(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Flex, Object.assign({ w: "100%", mb: "stack.small" }, props), children));
}

export { TableHeader };
